import React, { useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { CoFounderConnectBreadCrum } from '../core/_constants'
import { Form, Pagination } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import CofounderOpeningWidthCard from './CofounderOpeningWidthCard'
import CofounderDetails from './CofounderDetails'

const CofounderOpeningDetail: React.FC = () => {
    const { formatMessage } = useIntl()
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [pageNumbers, setPageNumbers] = useState<number[]>([]) //eslint-disable-line
    const [documentPerPage, setDocumentPerPage] = useState<number>(10)
    const [count, setCount] = useState<number>(0) //eslint-disable-line

    const handleDocumentsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setDocumentPerPage(Number(event.target.value))
        setCurrentPage(1)
    }

    return (
        <>
            <PageTitle
                breadcrumbs={CoFounderConnectBreadCrum}
                description={formatMessage({ id: 'Co-Founder Connect' })}
            >
                {formatMessage({ id: 'Co-Founder Connect' })}
            </PageTitle>
            <div className='px-6'>
                <Link to={'../'} className='bg-transparent text-primary border-0'><i className="fa-solid fa-arrow-left pe-2" style={{ color: '#4776e6' }}></i>{formatMessage({ id: 'Go back' })}</Link>
                <div className='my-6'>

                    <div className='p-4 bg-white rounded-3' style={{ height: 'auto' }}>
                        <CofounderDetails />
                    </div>
                    <div className='mt-4'>
                        <h1 className='font-size-20 my-4'>{formatMessage({ id: 'Co-Founders From Similar Industry' })}</h1>
                        {Array.from({ length: 4 }, (_, index) => (
                            <CofounderOpeningWidthCard key={index} />
                        ))}
                        <div
                            className={'w-100 d-flex justify-content-between align-items-center px-0 mt-8'}
                        >
                            <div className='d-flex gap-2 w-100 align-items-center'>
                                <Form.Select
                                    aria-label='Default select example'
                                    className='px-4 py-3 w-80px'
                                    value={documentPerPage}
                                    onChange={handleDocumentsPerPageChange}
                                >
                                    <option value='10'>{formatMessage({ id: '10' })}</option>
                                    <option value='20'>{formatMessage({ id: '20' })}</option>
                                    <option value='50'>{formatMessage({ id: '50' })}</option>
                                    <option value='100'>{formatMessage({ id: '100' })}</option>
                                </Form.Select>
                                <span className='font-size-13'>
                                    {`Showing ${(currentPage - 1) * documentPerPage + 1} to ${Math.min(
                                        (currentPage - 1) * documentPerPage + 1 + documentPerPage - 1,
                                        count
                                    )} of ${count} records`}
                                </span>
                            </div>
                            <Pagination className='w-100 d-flex flex-end'>
                                <Pagination.First
                                    key='first'
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(1)}
                                />
                                <Pagination.Prev
                                    key='prev'
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage((p) => p - 1)}
                                />
                                {pageNumbers.map((number) => (
                                    <Pagination.Item
                                        key={number}
                                        active={number === currentPage}
                                        onClick={() => setCurrentPage(number)}
                                    >
                                        {number}
                                    </Pagination.Item>
                                ))}
                                {pageNumbers.length > 6 && (
                                    <>
                                        {currentPage < pageNumbers.length - 3 && <Pagination.Ellipsis />}
                                        {currentPage >= pageNumbers.length - 3 && (
                                            <Pagination.Item>{pageNumbers.length}</Pagination.Item>
                                        )}
                                    </>
                                )}
                                <Pagination.Next
                                    key='next'
                                    disabled={currentPage === pageNumbers.length}
                                    onClick={() => setCurrentPage((p) => p + 1)}
                                />
                                <Pagination.Last
                                    key='last'
                                    disabled={currentPage === pageNumbers.length}
                                    onClick={() => setCurrentPage(pageNumbers[pageNumbers.length - 1])}
                                />
                            </Pagination>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default CofounderOpeningDetail